require("bootstrap/dist/css/bootstrap.css");
require("../css/base.css");
require("../css/styles.css");
require("../css/fonts.css");

const spritesheetUrl = require("../assets/images/spritesheet_v3.webp");

const DEV_HOSTS = [
  "localhost",
  "matriket-lidl-se.dev.mh.schwarz",
  "gnista.availsthlm.se",
];
const isDevEnvironment = DEV_HOSTS.includes(window.location.hostname);

const clickEvent =
  "touchstart" in document.documentElement ? "touchstart" : "click";

document.addEventListener("DOMContentLoaded", () => {
  const video = document.getElementById("balloon-video");
  const canvas = document.getElementById("balloon-canvas");

  if (video && canvas) {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    const useCanvas = isIOS || isSafari;

    if (useCanvas) {
      video.style.display = "none";
      canvas.style.display = "block";

      const COLS = 18;
      const ROWS = 10;
      const TOTAL_FRAMES = COLS * ROWS;
      const FRAME_SIZE = 500;
      const FPS = 30;
      const FRAME_DURATION = 1000 / FPS;

      canvas.width = FRAME_SIZE;
      canvas.height = FRAME_SIZE;
      canvas.style.width = video.style.width || "";

      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = spritesheetUrl;

      let frame = 0;
      let lastTime = 0;

      function tick(timestamp) {
        if (timestamp - lastTime >= FRAME_DURATION) {
          const col = frame % COLS;
          const row = Math.floor(frame / COLS);
          ctx.clearRect(0, 0, FRAME_SIZE, FRAME_SIZE);
          ctx.drawImage(
            img,
            col * FRAME_SIZE,
            row * FRAME_SIZE,
            FRAME_SIZE,
            FRAME_SIZE,
            0,
            0,
            FRAME_SIZE,
            FRAME_SIZE
          );
          frame = (frame + 1) % TOTAL_FRAMES;
          lastTime = timestamp;
        }
        requestAnimationFrame(tick);
      }

      img.onload = () => requestAnimationFrame(tick);
    }
  }
});

let marketingCookiesAccepted = false;

function hideCookieNotices() {
  const n1 = document.getElementById("yt-1-cookie-notice");
  const n2 = document.getElementById("yt-2-cookie-notice");
  if (n1) n1.style.display = "none";
  if (n2) n2.style.display = "none";
}

function handleMarketingCookieConsent() {
  if (isDevEnvironment || OnetrustActiveGroups.includes("C0004")) {
    marketingCookiesAccepted = true;
    hideCookieNotices();
    if (window.YT && typeof window.onYouTubeIframeAPIReady === "function") {
      window.onYouTubeIframeAPIReady();
    }
  } else {
    marketingCookiesAccepted = false;
  }
}

window.addEventListener("OneTrustGroupsUpdated", () => {
  handleMarketingCookieConsent();
});

// YouTube player functionality
let player1, player2;

function makePlayerHandlers(overlayId, iconId, cookieNoticeId) {
  const state = { isPlaying: false };

  function showOverlay(overlay, icon) {
    overlay.classList.add("fade-in");
    overlay.classList.remove("fade-out");
    icon.classList.add("fade-in");
    icon.classList.remove("fade-out");
  }

  function hideOverlay(overlay, icon) {
    overlay.classList.remove("fade-in");
    overlay.classList.add("fade-out");
    icon.classList.remove("fade-in");
    icon.classList.add("fade-out");
  }

  function onStateChange(event) {
    if (event.data === 2 || event.data === 0) {
      state.isPlaying = false;
      const overlay = document.getElementById(overlayId);
      const icon = document.getElementById(iconId);
      showOverlay(overlay, icon);
    }
  }

  function onReady(event) {
    const overlay = document.getElementById(overlayId);
    const icon = document.getElementById(iconId);

    function handleClick() {
      if (!marketingCookiesAccepted) {
        const notice = document.getElementById(cookieNoticeId);
        if (notice) notice.style.display = "flex";
        return;
      }
      try {
        if (!state.isPlaying) {
          hideOverlay(overlay, icon);
          event.target.playVideo();
          state.isPlaying = true;
        } else {
          showOverlay(overlay, icon);
          event.target.pauseVideo();
          state.isPlaying = false;
        }
      } catch (error) {
        console.error("Error handling player click:", error);
      }
    }

    icon.addEventListener(clickEvent, handleClick);
    overlay.addEventListener(clickEvent, handleClick);
  }

  return { onReady, onStateChange };
}

const player1Handlers = makePlayerHandlers("yt-1-overlay", "yt-1-play-icon", "yt-1-cookie-notice");
const player2Handlers = makePlayerHandlers("yt-2-overlay", "yt-2-play-icon", "yt-2-cookie-notice");

window.onYouTubeIframeAPIReady = function () {
  console.log("YouTube API Ready");
  if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
    console.error("YouTube Player API not available");
    return;
  }
  hideCookieNotices();

  /**
   * 
   * Lidl 1 09s 16x9 - https://youtu.be/69JVqlTVn4k
LIDL MATRIKET BTS MAIN - https://youtu.be/inXZR3sH7Cw
 
 
 
   */
  const videoId = "69JVqlTVn4k";
  const currentOrigin = window.location.origin;
  const sharedPlayerVars = {
    playsinline: 1,
    controls: 0,
    enablejsapi: 1,
    iv_load_policy: 3,
    origin: currentOrigin,
  };

  try {
    player1 = new YT.Player("youtube-video-1", {
      videoId,
      host: "https://www.youtube-nocookie.com",
      playerVars: sharedPlayerVars,
      events: {
        onReady: player1Handlers.onReady,
        onStateChange: player1Handlers.onStateChange,
      },
    });

    player2 = new YT.Player("youtube-video-2", {
      videoId: "inXZR3sH7Cw",
      host: "https://www.youtube-nocookie.com",
      playerVars: sharedPlayerVars,
      events: {
        onReady: player2Handlers.onReady,
        onStateChange: player2Handlers.onStateChange,
      },
    });
  } catch (error) {
    console.error("Error initializing YouTube players:", error);
  }
};

window.OptanonWrapper = function () {
  console.log("OptanonWrapper called");
  if (isDevEnvironment) {
    if (!window.YT) {
      console.log("Loading YouTube API on dev");
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    } else {
      console.log("YouTube API already loaded, initializing players");
      onYouTubeIframeAPIReady();
    }
  } else {
    console.log("Loading YouTube API through OneTrust");
    OneTrust.InsertScript(
      "https://www.youtube.com/iframe_api",
      "head",
      null,
      null,
      "C0004"
    );
  }
};
